import axios from 'axios';

const API_URL = '/api/tenant/inventory';

export const registerInventoryMovement = async (movementData) => {
  try {
    const response = await axios.post(`${API_URL}/movements`, movementData);
    return response.data;
  } catch (error) {
    console.error('Error registering inventory movement:', error);
    throw error;
  }
};

export const fetchExistenceReportData = async (params = {}) => {
  try {
    const response = await axios.get(`${API_URL}/report/existence/data`, { params });
    return response.data;
  } catch (error) {
    console.error('Error fetching existence report data:', error);
    throw error;
  }
};

export const downloadExistenceReport = async (params = {}) => {
  try {
    const response = await axios.get(`${API_URL}/report/existence`, {
      params,
      responseType: 'blob',
    });
    return response.data;
  } catch (error) {
    console.error('Error downloading existence report:', error);
    throw error;
  }
};
